import { Nav1, Nav3 } from '@bm-js/atlascloud-ui'
import { useMemo } from 'react'
import {
  WebsiteConfigPage,
  WebsiteConfigPageFM,
} from '@bm-js/atlascloud-shared'
import Nav2 from '../Nav2'
import LinkComponent from '../LinkComponent'
import {
  useEditorActions,
  useEditorData,
  useEditorWebsite,
} from '../../utils/hooks'

const NavSwitcher = () => {
  const { activePage, workingConfig, breadcrumbs } = useEditorData()
  const { features } = useEditorWebsite()
  const { setActivePage } = useEditorActions()

  const darkNav = useMemo(() => {
    const contentName = activePage?.content?.[0]?.name
    const darkNavTopComponents = ['videoHero', 'topsection']
    return contentName && !darkNavTopComponents.includes(contentName)
  }, [activePage])

  const scrollElement = document.querySelector('.website-contents')!
  const mapPageToFM = (page: WebsiteConfigPage): WebsiteConfigPageFM => ({
    ...page,
    slug: '',
    fullPath: '',
    meta: { title: '', description: '' },
    children: page.children?.map(mapPageToFM) || [],
  })

  switch (workingConfig?.navType) {
    case 'nav1':
      return (
        <Nav1
          contactInfo={workingConfig.contactInfo}
          logoWide={workingConfig.logoWide}
          navTree={workingConfig.pages.map(mapPageToFM)}
          scrollElement={scrollElement}
          setActivePageFromNav={(p) => setActivePage(p.uuid)}
          LinkComponent={LinkComponent}
        />
      )
    case 'nav2':
      return (
        <Nav2
          websiteConfig={workingConfig}
          features={features}
          getPagePath={() => breadcrumbs}
          setActivePageFromNav={(p) => setActivePage(p.uuid)}
        />
      )
    case 'nav3':
      return (
        <Nav3
          contactInfo={workingConfig.contactInfo}
          logoWide={workingConfig.logoWide}
          navTree={workingConfig.pages.map(mapPageToFM)}
          setActivePageFromNav={(p) => setActivePage(p.uuid)}
          dark={darkNav}
          scrollElement={scrollElement}
          LinkComponent={LinkComponent}
        />
      )
    default:
      return null
  }
}

export default NavSwitcher
